
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Corporatecabserviceinnavimumbai() {



    const cardData =
    {
        keyword: 'Corporate Cab Services in Navi Mumbai Airport  ',
        heading: 'etravo : Corporate Cab Services in Navi Mumbai Airport',



"headingDescription": "eTravo offers reliable Corporate Cab Services in Navi Mumbai Airport, designed for businesses, executives, and corporate teams requiring seamless airport transfers, client pickups, and employee transportation. With GPS-enabled vehicles, professional chauffeurs, and real-time scheduling, eTravo ensures safe, punctual, and comfortable travel to and from Navi Mumbai International Airport and surrounding business hubs. Flexible booking options make it an ideal solution for corporate travel needs.",

"top": "Top Corporate Cab Service Areas near Navi Mumbai Airport with eTravo",

"topPlaces": [
  {
    "title": "Navi Mumbai International Airport Zone",
    "description": "A major upcoming aviation hub requiring reliable corporate cab services for airport transfers, executive travel, and business arrivals."
  },
  {
    "title": "CBD Belapur Business District",
    "description": "A key corporate and administrative hub with offices, banks, and government institutions requiring regular airport transfers."
  },
  {
    "title": "Vashi Commercial Hub",
    "description": "A well-developed business area with corporate offices and shopping complexes, generating consistent demand for corporate cab services."
  },
  {
    "title": "Airoli IT Park",
    "description": "A prominent IT hub in Navi Mumbai with major companies requiring employee transport and airport connectivity."
  },
  {
    "title": "Ghansoli Corporate Zone",
    "description": "A fast-growing corporate area with IT parks and offices requiring reliable cab services for daily commute and airport transfers."
  },
  {
    "title": "Turbhe Industrial Area",
    "description": "An industrial and logistics hub where companies need efficient transport for employees and business travel."
  },
  {
    "title": "Mahape MIDC",
    "description": "A major IT and industrial zone with corporate offices requiring structured employee transportation and airport connectivity."
  },
  {
    "title": "Kharghar Business District",
    "description": "A developing corporate and residential hub near the airport, supporting executive travel and daily commuting."
  },
  {
    "title": "Panvel Industrial & Logistics Hub",
    "description": "A strategic area near the airport with warehouses and industries requiring corporate mobility solutions."
  },
  {
    "title": "Seawoods Corporate Zone",
    "description": "A premium commercial area with offices and business centers requiring executive cab services and airport transfers."
  }
],


"services": [
{
"name": "Corporate Cab Navi Mumbai Airport",
"description": "eTravo offers reliable corporate cab services for Navi Mumbai Airport with punctual pickups and professional chauffeurs. Our service ensures smooth airport transfers for executives and business travelers with complete comfort and efficiency."
},
{
"name": "Airport Taxi Navi Mumbai Corporate",
"description": "Our corporate airport taxi services in Navi Mumbai provide dependable transportation for business needs. eTravo ensures timely service, clean vehicles, and hassle-free travel to and from the airport."
},
{
"name": "Airport Pickup Navi Mumbai Corporate",
"description": "eTravo provides corporate airport pickup services in Navi Mumbai with a focus on punctuality and professionalism. Our service ensures smooth arrivals for executives and employees."
},
{
"name": "Airport Drop Navi Mumbai Corporate",
"description": "Our airport drop services in Navi Mumbai are designed for stress-free corporate travel. eTravo ensures timely departures and reliable transportation for business professionals."
},
{
"name": "Corporate Airport Transfer Navi Mumbai",
"description": "eTravo offers corporate airport transfer services in Navi Mumbai for seamless travel. Our service ensures efficient coordination, comfortable rides, and punctual service for all corporate needs."
},
{
"name": "Business Airport Cab Navi Mumbai",
"description": "Our business airport cab services in Navi Mumbai are ideal for professionals traveling for meetings and corporate purposes. eTravo ensures reliable and comfortable airport transportation."
},
{
"name": "Company Airport Taxi Navi Mumbai",
"description": "eTravo provides company airport taxi services in Navi Mumbai tailored for corporate requirements. Our service ensures efficient and dependable travel for employees and executives."
},
{
"name": "Executive Airport Cab Navi Mumbai",
"description": "Experience premium travel with eTravo’s executive airport cab services in Navi Mumbai. Our vehicles provide comfort, privacy, and professional service for senior management and VIP clients."
},
{
"name": "Airport Cab Booking Navi Mumbai",
"description": "eTravo makes airport cab booking in Navi Mumbai simple and convenient. Our service ensures reliable vehicles and timely pickups for all corporate travel needs."
},
{
"name": "Corporate Travel Airport Navi Mumbai",
"description": "eTravo offers corporate travel services for airport transfers in Navi Mumbai. Our service ensures smooth and dependable transportation for business trips and official travel."
},
{
"name": "Staff Airport Pickup Navi Mumbai",
"description": "eTravo provides staff airport pickup services in Navi Mumbai for efficient employee travel. Our service ensures punctual pickups and comfortable rides for workforce mobility."
},
{
"name": "Airport Transfer Services Navi Mumbai",
"description": "Our airport transfer services in Navi Mumbai are designed for seamless and reliable travel. eTravo ensures safe, timely, and comfortable transportation for corporate clients."
},
{
"name": "Office Airport Cab Navi Mumbai",
"description": "eTravo offers office airport cab services in Navi Mumbai for employees traveling for work. Our service ensures convenient and dependable transportation to and from the airport."
},
{
"name": "Professional Airport Taxi Navi Mumbai",
"description": "eTravo provides professional airport taxi services in Navi Mumbai with trained drivers and well-maintained vehicles. Our service ensures safe and comfortable travel for corporate clients."
},
{
"name": "Corporate Airport Commute Navi Mumbai",
"description": "eTravo’s corporate airport commute services in Navi Mumbai provide structured and efficient transportation for business travelers. Our service ensures smooth travel between offices and airports."
}
],
"tableData": [
["Corporate Cab Navi Mumbai Airport", "Airport Taxi Navi Mumbai Corporate"],
["Airport Pickup Navi Mumbai Corporate", "Airport Drop Navi Mumbai Corporate"],
["Corporate Airport Transfer Navi Mumbai", "Business Airport Cab Navi Mumbai"],
["Company Airport Taxi Navi Mumbai", "Executive Airport Cab Navi Mumbai"],
["Airport Cab Booking Navi Mumbai", "Corporate Travel Airport Navi Mumbai"],
["Staff Airport Pickup Navi Mumbai", "Airport Transfer Services Navi Mumbai"],
["Office Airport Cab Navi Mumbai", "Professional Airport Taxi Navi Mumbai"],
["Corporate Airport Commute Navi Mumbai", ""]
],




"whychoose": [
    {
      "WhyChooseheading": "Reliable Corporate Cab Services in Navi Mumbai Airport",
      "WhyChoosedescription": "eTravo provides dependable corporate cab services in Navi Mumbai Airport, ensuring smooth and efficient transportation for business travelers, employees, and executives."
    },
    {
      "WhyChooseheading": "Seamless Airport Transfers for Corporate Travel",
      "WhyChoosedescription": "Our airport cab services include timely pickup and drop, flight tracking, and real-time coordination to ensure hassle-free arrivals and departures."
    },
    {
      "WhyChooseheading": "Ideal for Executive and VIP Travel",
      "WhyChoosedescription": "Corporate cab services are perfect for executives and VIP clients, offering premium vehicles and professional service for a comfortable travel experience."
    },
    {
      "WhyChooseheading": "Wide Fleet for Airport Transportation",
      "WhyChoosedescription": "We provide a variety of vehicles including sedans, SUVs, and luxury cars suitable for individual travelers, teams, and corporate groups."
    },
    {
      "WhyChooseheading": "Punctual and Time-Sensitive Service",
      "WhyChoosedescription": "With strict adherence to schedules and flight monitoring, eTravo ensures timely pickups and drop-offs for all airport transfers."
    },
    {
      "WhyChooseheading": "Professional Chauffeurs with Airport Expertise",
      "WhyChoosedescription": "Our drivers are experienced with Navi Mumbai airport routes and traffic patterns, ensuring efficient and stress-free travel."
    },
    {
      "WhyChooseheading": "Flexible Corporate Billing and Plans",
      "WhyChoosedescription": "We offer corporate billing, monthly contracts, and GST-compliant invoicing for easy expense management."
    },
    {
      "WhyChooseheading": "24/7 Availability for Business Travelers",
      "WhyChoosedescription": "Our services operate round the clock to support early morning flights, late-night arrivals, and urgent corporate travel needs."
    }
  ]

}

const faqData = [
    [
        {
            question: 'What are corporate cab services in Navi Mumbai Airport?',
            answer: 'Corporate cab services provide professional transportation for business travelers including airport pickup, drop, and transfer services.',
        },
        {
            question: 'Do airport cab services include flight tracking?',
            answer: 'Yes, most services include flight tracking to adjust pickup timings based on delays or early arrivals.',
        },
        {
            question: 'Can companies book airport cabs for employees?',
            answer: 'Yes, companies can book airport cab services for employees, executives, and clients.',
        },
        {
            question: 'What types of vehicles are available for airport travel?',
            answer: 'Vehicles include hatchbacks, sedans, SUVs, and luxury cars depending on travel needs.',
        },
        {
            question: 'Are airport cab services available 24/7?',
            answer: 'Yes, services operate round the clock to support all flight schedules.',
        },
        {
            question: 'Do airport cab services provide corporate billing?',
            answer: 'Yes, providers offer GST-compliant invoices and corporate billing options.',
        },
        {
            question: 'Is airport cab service safe for corporate travelers?',
            answer: 'Yes, services include verified drivers, GPS tracking, and safety protocols.',
        },
        {
            question: 'Can airport cab services be customized?',
            answer: 'Yes, travel plans can be customized based on company requirements.',
        },
        {
            question: 'Are services suitable for VIP travel?',
            answer: 'Yes, premium and luxury vehicles are available for VIP and executive travel.',
        },
        {
            question: 'How can I book corporate cab services in Navi Mumbai Airport?',
            answer: 'You can book online or contact the support team for quick and customized corporate booking.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Rohit Shah',
        designation: 'Business Consultant, Navi Mumbai',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo’s corporate cab service at Navi Mumbai Airport is very reliable. Their punctuality and smooth coordination make travel stress-free.”',
    },
    {
        name: 'Ms. Pooja Mehta',
        designation: 'HR Manager, Corporate Firm, Navi Mumbai',
        rating: [1, 1, 1, 1, 1],
        text: '“We use eTravo for airport transfers regularly. Their professional drivers and timely service ensure a seamless experience for our employees.”',
    },
];




    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Services in Navi Mumbai Airport",
  "image": "https://www.etravo.in/images/keyword/corporate-cab-navi-mumbai-airport.jpg",
  "description": "Reliable corporate cab services for Navi Mumbai Airport by eTravo. Ideal for airport pickup and drop, executive transfers, business travel, and corporate airport commute with safe and timely service.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "1250"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2199",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cab-services-in-navi-mumbai-airport"
  }
};





    return (
        <div>


<Helmet>
  <title>Corporate Cab Services in Navi Mumbai Airport | Airport Pickup & Drop | eTravo</title>
  <meta 
    name="description" 
    content="Book corporate cab services at Navi Mumbai Airport with eTravo for airport pickup and drop, executive travel, business transfers, and corporate airport commute solutions." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/144.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Corporatecabserviceinnavimumbai;